module.exports = __webpack_public_path__ + "img/officialSwiper3.ad3ff6f6.png";